package com.example.mystybag.sharedmodels.mystyBag.requestModels

import com.example.mystybag.sharedmodels.AllCommands.GENERATE_EMAIL_VERIFICATION_CODE
import com.example.mystybag.sharedmodels.base.BaseRequestModel
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class GenerateEmailVerificationCodeRequestModel(
    val userId: Long = 0,
    val newEmail: String = ""
) : BaseRequestModel(api = GENERATE_EMAIL_VERIFICATION_CODE)
